import { AnalyticsConfiguration } from '@rci/self-serve-fido/core/analytics/analytics-config/analytics-configuration';
import {
  interactionEvent,
  notificationEvent,
} from '@rci/self-serve-fido/core/analytics/analytics-config/global-analytics-configuration';

const getMappings = (hierarchy: string): AnalyticsConfiguration => {
  return {
    mappings: {
      alertCtaTracking: {
        events: interactionEvent,
        page: { name: hierarchy, hierarchy: ['myaccount', `${hierarchy}`] },
      },
      suspensionAlert: {
        events: notificationEvent,
        page: { name: hierarchy, hierarchy: ['myaccount', `${hierarchy}`] },
      },
    },
  };
};

export const earlySuspensionAnalyticsConfig = {
  alertCtaTracking: {},
  displayAlertTracking: {},
};

export const earlySuspensionAnalyticsConfiguration = (hierarchy: string): AnalyticsConfiguration => {
  return getMappings(hierarchy);
};
